import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';
import type { NuxtApp } from '#app';

// https://iad-holding.atlassian.net/browse/WEB-749
export default defineNuxtPlugin({
  name: 'page-tracking',
  // https://nuxt.com/docs/api/advanced/hooks
  hooks: {
    'app:mounted'() {
      const nuxtApp = useNuxtApp();
      const route = useRoute();
      trackPage(nuxtApp, route);
    },
    'page:start'() {
      const nuxtApp = useNuxtApp();
      const route = useRoute();
      trackPage(nuxtApp, route);
    },
  },
});

function trackPage(nuxtApp: NuxtApp, route: RouteLocationNormalizedLoadedGeneric) {
  if (nuxtApp.$config.public.tracking.environment === `test`) return;
  if ('dataLayer' in window && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: 'pageview',
      p_country: nuxtApp.$config.public.tracking.country,
      p_language: nuxtApp.$i18n.locale.value,
      p_environment: nuxtApp.$config.public.tracking.environment,
      p_site: nuxtApp.$config.public.tracking.site,
      p_template: route.meta.pageTemplate ?? ``,
      p_title: window.document.title,
      p_type: route.meta.pageType ?? ``,
      p_path: window.location.pathname,
    });
  }
}
